import HLayout from "@/layout/P";
import userrouter from "./user";
const routes = [
  {
    path: "/",
    name: "index",
    component: HLayout,
    children: [
      {
        path: "",
        redirect: "index",
      },
      {
        path: "index",
        name: "index",
        component: (resolve) => require(["pages/pc/index.vue"], resolve),
        meta: { showLeftMenu: false, requiresAuth: false },
      },

      {
        path: "login",
        name: "login",
        component: (resolve) => require(["pages/pc/login"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
          guestOnly: true,
        },
      },
      {
        path: "forget",
        name: "forget",
        component: (resolve) => require(["pages/pc/forget"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
          guestOnly: true,
        },
      },
      {
        path: "register",
        name: "register",
        component: (resolve) => require(["pages/pc/register"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
          guestOnly: true,
        },
      },
      {
        path: "lists",
        name: "lists",
        component: (resolve) => require(["pages/pc/lists/index"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
        },
      },
      {
        path: "detail/:id",
        name: "detail",
        component: (resolve) => require(["pages/pc/lists/detail"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
        },
      },
      {
        path: "book_lists",
        name: "book_lists",
        component: (resolve) => require(["pages/pc/book/lists"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
        },
      },
      {
        path: "book_detail/:id",
        name: "book_detail",
        component: (resolve) => require(["pages/pc/book/detail"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: false,
        },
      },
      {
        path: "cart",
        name: "cart",
        component: (resolve) => require(["pages/pc/cart"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: true,
        },
      },
      {
        path: "orders/confirm",
        name: "ordersConfirm",
        component: (resolve) => require(["pages/pc/orders/confirm"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: true,
        },
      },
      {
        path: "orders/detail/:id",
        name: "ordersDetail",
        component: (resolve) => require(["pages/pc/orders/detail"], resolve),
        meta: {
          showLeftMenu: false,
          requiresAuth: true,
        },
      },
      ...userrouter,
    ],
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/pc/index.js